import { Input, NumericInput } from "Components/Form/Input";

import Popover from "@storeblocks/popover";
import { InputMode } from "Components/Form/Input/inputTypes";
import { TextManager } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { BoatProductIntroFormValues } from "./boatProductIntroInterfaces";

interface Props {
  formProps: FormikProps<Partial<BoatProductIntroFormValues>>;
  formText: any;
  lang: string;
}

export const CommonFormElementsMotorOrSail = ({
  formProps,
  formText,
  lang,
}: Props): React.ReactElement => {
  const { getText } = TextManager;

  return (
    <>
      {formProps.values.registeredInSmaabaatregisteret ===
        BooleanFormType.TRUE && (
        <Input
          name="registrationNumber"
          id={formText.registrationNumber.id}
          label={formText.registrationNumber.label[lang]}
          error={getError("registrationNumber", formProps)}
          inputProps={{ maxLength: 10 }}
          inputMode={InputMode.TEXT}
        />
      )}
      <Input
        id="brandAndModel"
        name="brandAndModel"
        label={getText("boatform.label.brandandmodel")}
        error={getError("brandAndModel", formProps)}
        large
        inputProps={{ maxLength: 20 }}
        inputMode={InputMode.TEXT}
        labelPopover={
          <Popover>{getText("boatform.hint.brandandmodel")}</Popover>
        }
      />
      <NumericInput
        id="modelYear"
        name="modelYear"
        label={getText("boatform.label.modelyear")}
        error={getError("modelYear", formProps)}
        inputMode={InputMode.NUMERIC}
        formatted={false}
        inputProps={{ maxLength: 4 }}
      />
      <NumericInput
        id="lengthInFeet"
        name="lengthInFeet"
        label={getText("boatform.label.lengthinfeet")}
        error={getError("lengthInFeet", formProps)}
        inputMode={InputMode.NUMERIC}
        inputProps={{ maxLength: 2 }}
      />
    </>
  );
};
